<template>
    <div class="ps-re">
        <div class="fitW">

            <el-tree
                    ref="tree"
                    :data="treeData"
                    lazy :key="treeId"
                    :load="loadNode"
                    :props="defaultProps"
                    node-key="wyid"
                    @node-click="handleNodeClick"
                    :default-expanded-keys="['0-0']"
                    class="trees  video-tree height100"
                    accordion
                    :highlight-current='true'
                    :expand-on-click-node="false">
                <div class="custom-tree-node" style="width: 100%"  slot-scope="{ node, data }">
                        <span >
<!--                                <i class="el-icon-folder-opened"></i>-->

                                <i :class="data.type==1?'el-icon-folder-opened':'el-icon-document'" style="padding-right: 5px"></i>
                                <span>{{ node.label }}</span>

                        </span>
                </div>
            </el-tree>

        </div>
    </div>

</template>

<script>
    // import * as API from "./api"
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "ProductTree",
        // props:{
        //     data:{
        //         type: Number,
        //         required:true,
        //     },
        // },
        components: {},
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_id'
                },
                i_state:1,
                treeData:[{i_id:0,i_level:1, type:1,i_pid:0,label:'全部',children:[],isLeaf:false}],
                treeId:0,
                showMenuId:null,

            }
        },
        mounted() {
            let that=this,box=document.getElementById('tabelBox');
            box.addEventListener('mouseup',function (event) {
                if(event.button===0||event.button==2){
                    // console.log('down------------------')
                    that.showMenuId=null

                }
            })
        },
        methods: {
            handleNodeClick(val){
                this.showMenuId=null;
                let data=JSON.parse(JSON.stringify(val))
                this.$emit('showData',data)
            },
            loadNode(node, resolve) {
                this.showMenuId=null;
                let _this=this;
                if (node.level === 0) {
                    let val={i_id:0,i_level:0, i_typepid:0,type:1,i_pid:0,label:'全部',vc_name:'全部',children:[],childProduct:0,wyid:'0-0',isLeaf:false};
                    return resolve([val]);
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.productTree(node.data,resolve,node.level);
                }
            },
            async productTree({i_id=0,type=0},resolve,level){
                let param = {
                    // i_mid: this.mid,
                    i_pid:i_id,
                    isuse:this.i_state,
                };
                let res = await API.productTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash=one;
                            hash.isLeaf= one.childProduct==0&&one.childKind==0;
                            hash.i_level= level;
                            hash.label= one.vc_name;
                            hash.wyid=one.i_typepid+'-'+one.i_id

                            //     {
                            //     label:one.vc_name,
                            //     i_id:one.i_id,
                            //     type:one.type,
                            //     i_level:level+1,
                            //     // i_pid:one.i_pid,
                            //     isLeaf: one.childProduct==0,
                            // };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
           },
    }
</script>

<style lang="scss" scoped>
    .fitW{
        width: fit-content;
    }
    .ps-re{
    position: relative;

    }
    .usebutton{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 99;
    }
    /deep/ {
        .el-tree-node__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-tree-node__content{
            width: 100%;
        }
    }
        .menu{
            /*display: flex;*/
            border: 1px solid #8e8e8e;
            right: 0;
            position: absolute;
            background-color: #fff;
            box-shadow:0 2px 8px rgba(0,0,0,0.1);
        }
    .info{
        /*border: 1px solid #8e8e8e;*/
padding: 5px 15px;
    }
    .info:hover{
        background-color: #CCCCCC;

    }
.el-tree span{
    display: inline-block;
    width: 100%;
}
</style>